(function($) {
  $(function() {
    // Call the L2 inline for backward compat
    // Note that prodcat.data is defined in head so the L2 call needs to be
    // generated in the footer
    prodcat.data.initialL2Call();
  });
})(jQuery);
